import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {TextField} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TypeEntity from "../../../../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {SelectionCriteriaContext} from "../SelectionCriteriaContext";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../Utils/lib";
import DefaultType from "../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import SettingsMenu from "../../SelectionCriteriaDev/SettingsMenu";
import SelectType from "../../../../../../Utils/Form/FormDynamic/Fields/SelectType/Select";

const Option = (props) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [focusedField, setFocusedField] = useState('');
    const [tabPressed, setTabPressed] = useState(false);
    const {field, index, path, firstDisabledValue} = props;
    const {
        currentFilterFront, listName, disabled, filterFields, actions
    } = useContext(SelectionCriteriaContext);

    function onKeyDownColumn(event, index, value) {
        // const applyButton = document.getElementById(`${listName}_applyFilterBtn`);
        const operandField = document.getElementById(`${listName}_${index}_operandField`);
        //const valueField = document.getElementById(`${listName}_${index}_filterValueField`);
        if (event.keyCode === 13) {
            //do not focus anything , if operand value is present

            event.preventDefault();
            setTimeout(() => {
                if (operandField.getAttribute('value')) {
                    return
                }
                operandField && operandField.focus();
            }, 50);

        }
        // if (event.keyCode === 13 && index > 0 && value.length === 0) {
        //     event.preventDefault();
        //     applyButton && applyButton.focus()
        // }
        // if (event.keyCode === 13 && index === 0 && value.length === 0) {
        //     event.preventDefault();
        //     applyButton && applyButton.focus()
        // }
    }

    function onKeyDownOperand(event, index) {
        const filterValueField = document.getElementById(`${listName}_${index}_filterValueField`);
        if (event.keyCode === 13) {
            event.preventDefault();
            setTimeout(() => {
                filterValueField && filterValueField.focus();
            }, 50);
        }
    }

    function onKeyDownValue(event) {
        if (event.key === "Tab" && !event.shiftKey) {
            setTabPressed(true)
        }
    }

    function onRowKeyDown(event, index) {
        if (event.keyCode === 27 && !menuIsOpen) {
            actions.onCloseFilterOptions()
        }
        //delete all filters shift+ctrl+del
        if (event.ctrlKey && event.shiftKey && event.keyCode === 46) {
            event.preventDefault();
            actions.onDeleteAllFilters();
            document.getElementById(`${listName}_0_columnField`).focus();
            return;
        }
        //apply filter ctrl+s
        if (event.ctrlKey && event.keyCode === 83) {
            event.preventDefault();
            actions.apply(event);
        }
        //delete row ctrl+delete
        if (event.ctrlKey && event.keyCode === 46) {
            event.preventDefault();
            actions.onDeleteFilter(index);
            if (index > 1) {
                document.getElementById(`${listName}_${index - 1}_columnField`).focus();
            } else {
                document.getElementById(`${listName}_0_columnField`).focus();
            }
        }
    }

    function onFocusField(name) {
        setFocusedField(name)
    }

    function onBlurField(event, index) {
        setFocusedField('')
        if (tabPressed) {
            setTabPressed(false)

            function focusNext() {
                setTimeout(() => {
                    let nextInput = document.getElementById(`${listName}_${index + 1}_columnField`);
                    nextInput && nextInput.focus();
                }, 50)
            }

            actions.onCreateFilter(event, index, focusNext);
        }
        setTabPressed(false)

    }

    return (
        <div
            onKeyDown={(event) => onRowKeyDown(event, index)}
            style={{display: 'inline-flex', alignItems: 'anchor-center'}}
        >
            <ColumnField
                field={field}
                index={index}
                onChange={actions.onChangeField}
                onKeyDown={onKeyDownColumn}
                disabled={disabled}
                columnsToFilter={filterFields}
                listName={listName}
                path={path}
            />
            <OperandField
                field={field}
                index={index}
                onChange={actions.onChangeOperand}
                onKeyDown={onKeyDownOperand}
                disabled={disabled}
                listName={listName}
                path={path}
            />
            <ValueField
                disabled={disabled}
                onKeyDown={onKeyDownValue}
                onBlur={onBlurField}
                onFocus={onFocusField}
                onChange={actions.onChangeFilterValue}
                onChangeEntityExternal={actions.onChangeFilterValueExternal}
                onChangeRange={actions.onChangeFilterValueRange}
                currentFilterFront={currentFilterFront}
                focusedField={focusedField}
                setMenuIsOpen={setMenuIsOpen}
                field={field}
                listName={listName}
                index={index}
                path={path}
                firstDisabledValue={firstDisabledValue}
            />
        </div>
    )
};
export default Option;
Option.propTypes = {
    index: PropTypes.number,
    field: PropTypes.object.isRequired,
    columnsToFilter: PropTypes.array,
    disabled: PropTypes.bool,
    firstDisabledValue: PropTypes.number,
};


const useStylesColumnField = makeStyles(() => ({
    inputRoot: {
        paddingRight: "23px !important",
        '&[class*="MuiInput-root"]': {
            padding: 1,
            '& input:first-child': {
                padding: '4px 0 !important',
            },
        },
    },
    clearIndicator: {
        display: 'none',
    },
    option: {
        minHeight: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        paddingTop: 1,
        boxSizing: 'border-box',
        outline: '0',
        WebkitTapHighlightColor: 'transparent',
        paddingBottom: 2,
        paddingLeft: 16,
        paddingRight: 16,
    },
    paper: {
        width: (props) => props.dropdownWidth || 230,
        '& > ul': {
            maxHeight: 200,
            overflow: 'auto',
        },
    },
}));
const ColumnField = (props) => {
    const {disabled, index, field, listName, onChange, onKeyDown, columnsToFilter, path} = props;
    const isDisabled = field.field.predefinedRequired || disabled;
    const {userLanguage} = useSelector(state => state.app);

    const options = (columnsToFilter || []).map(field => ({
        value: field.name,
        label: multiLanguageValue(field.label, userLanguage),
        type: field.type,
        operands: field.operands,
        required: field.required,
        entity: field.entity,
        schema: field.schema
    }));

    function calcDropdownWidth(labels = []) {
        if (labels.length > 0) {
            const maxLength = labels.reduce((a, b) => a.length >= b.length ? a : b).length * 10
            if(maxLength < 100) {
                return 290
            }
            return maxLength
        }
        return 290
    }

    const classes = useStylesColumnField({dropdownWidth: calcDropdownWidth(options.map(v => v.label))});

    const isAutofocus = Boolean(index === 0 && !isDisabled)

    return (
        <Autocomplete
            autoHighlight={isAutofocus}
            disableOpenOnFocus={true}
            filterSelectedOptions={true}
            disabled={isDisabled}
            index={index}
            options={options || []}
            getOptionLabel={option => multiLanguageValue(option.label, userLanguage) || ""}
            onChange={(event, value) => {
                onChange(event, value, path ? `${path + '.' + index}` : `${index}`)
            }}
            value={{value: field.field.value, label: multiLanguageValue(field.field.label, userLanguage)}}
            onKeyDown={(event) => onKeyDown(event, index, field.field.value)}
            style={{width: 180}}
            classes={{
                inputRoot: classes.inputRoot,
                clearIndicator: classes.clearIndicator,
                option: classes.option,
                paper: classes.paper
            }}
            renderInput={params => (
                <TextField {...params}
                           fullWidth
                           name={'column'}
                           autoFocus={isAutofocus}
                           inputProps={{...params.inputProps, id: `${listName}_${index}_columnField`}}
                           InputProps={{
                               ...params.InputProps,
                               disableUnderline: true
                           }}
                />
            )}
        />
    )
};
ColumnField.propTypes = {
    disabled: PropTypes.bool,
    index: PropTypes.number,
    field: PropTypes.object,
    listName: PropTypes.string,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    columnsToFilter: PropTypes.array
};

const OperandField = (props) => {
    const {index, disabled, field, listName, onChange, onKeyDown, path} = props;
    const classes = useStylesColumnField();
    const fieldValue = field.field.value;
    return (
        <Autocomplete
            //autoHighlight={true}
            disableOpenOnFocus={true}
            filterSelectedOptions={true}
            index={index}
            disabled={field.field.operands?.length === 1 || !fieldValue || !fieldValue.length > 0 || disabled}
            options={field.field.operands || []}
            getOptionLabel={option => option.label || ""}
            onChange={(event, value) => {
                onChange(event, value, path ? `${path + '.' + index}` : `${index}`)
            }}
            value={{value: field.operand.value, label: field.operand.label}}
            style={{width: 180}}
            classes={{
                inputRoot: classes.inputRoot,
                clearIndicator: classes.clearIndicator,
                option: classes.option,
                paper: classes.paper
            }}
            renderInput={params => (
                <TextField {...params}
                           fullWidth
                           name={'operand'}
                           inputProps={{...params.inputProps, id: `${listName}_${index}_operandField`}}
                           InputProps={{
                               ...params.InputProps,
                               disableUnderline: true
                           }}
                           onKeyDown={(event) => onKeyDown(event, index)}
                />
            )}
        />
    )
};
OperandField.propTypes = {
    index: PropTypes.number,
    disabled: PropTypes.bool,
    field: PropTypes.object,
    listName: PropTypes.string,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func
};

const ValueField = (props) => {
    const {
        field, listName, onChangeRange, onChangeEntityExternal, onFocus,
        onBlur, onKeyDown, focusedField, index, disabled, currentFilterFront, setMenuIsOpen, path,
        firstDisabledValue
    } = props;
    const {type: selectionType, hideValueTypeSelection} = useContext(SelectionCriteriaContext)
    const filterValueType = field.type;
    let type = field.field.type;
    const isRange = field.operand.value === 'range' || field.operand.value === 'notRange';

    if (!type) return <div style={{width: 290}}></div>

    if (type === 'datetime') {
        type = 'datetime-local'
    }

    function Settings() {
        if (selectionType === 'system' && !hideValueTypeSelection) {
            return <SettingsMenu
                path={path}
                index={index}
            />
        }
        return <></>
    }

    if (filterValueType === 'sbFunction') {
        return (
            <>
                <TypeEntity
                    field={{
                        name: 'value',
                        schema: {},
                        entity: "listQueryFunction",
                        path: path ? `${path + '.' + index}.value` : `${index}.value`,
                        isArray: field.operand.value === 'in',
                        disabled,
                        autofocus: firstDisabledValue === index
                    }}
                    setValue={onChangeEntityExternal}
                    fieldStyles={{withoutStyles: true, fullWidth: false, width: 285, withoutPadding: true}}
                    dropdownStyles={{width: 300}}
                    values={currentFilterFront}
                    onFocus={() => onFocus(`field_${index}`)}
                    onKeyDown={(event) => onKeyDown(event, field, index)}
                    setDropdownState={setMenuIsOpen}
                    id={`${listName}_${index}_filterValueField`}
                    onBlur={(event) => onBlur(event, index)}
                />
                <Settings/>
            </>
        )
    }

    if (filterValueType === 'string') {
        return (
            <>
                <DefaultType
                    field={{
                        name: 'filterText',
                        path: path ? `${path + '.' + index}.value` : `${index}.value`,
                        disabled: field.operand.value ? !field.operand.value.length > 0 : true,
                        type: 'string',
                        isArray: field.operand.value === 'in',
                        autofocus: firstDisabledValue === index
                    }}
                    values={currentFilterFront}
                    setValue={onChangeEntityExternal}
                    onKeyDown={(event) => onKeyDown(event, field, index)}
                    fieldStyles={{withoutStyles: true, fullWidth: false, width: 290}}
                    onFocus={() => onFocus(`field_${index}`)}
                    id={`${listName}_${index}_filterValueField`}
                    onBlur={(event) => onBlur(event, index)}
                />
                <Settings/>
            </>
        )
    }

    if (isRange) {
        return (
            <>
                <TextField
                    id={`${listName}_${index}_filterValueField`}
                    placeholder={'from'}
                    disabled={!field.operand || disabled}
                    autoFocus={firstDisabledValue === index}
                    type={type}
                    name={'value'}
                    index={index}
                    onFocus={() => onFocus(`from_${index}`)}
                    onBlur={onBlur}
                    onChange={(event) => onChangeRange(event, index)}
                    className={`filterTextField`}
                    value={field.value || ''}
                    InputProps={{
                        disableUnderline: `from_${index}` !== focusedField,
                        style: {padding: 0, width: (type === 'date' || type === 'datetime-local') ? 230 : 130}
                    }}
                    InputLabelProps={
                        {shrink: true}
                    }
                    inputProps={{
                        step: 1
                    }}
                />
                <TextField
                    id={`${listName}_${index}_toField`}
                    placeholder={'to'}
                    disabled={!field.operand || disabled}
                    type={type}
                    name={'value2'}
                    onFocus={() => onFocus(`to_${index}`)}
                    onBlur={e => onBlur(e, index)}
                    onKeyDown={(event) => onKeyDown(event, field, index)}
                    className={`filterTextField`}
                    onChange={(event) => onChangeRange(event, index)}
                    value={field.value2 || ''}
                    InputProps={{
                        disableUnderline: `to_${index}` !== focusedField,
                        style: {
                            padding: 0,
                            width: (type === 'date' || type === 'datetime-local') ? 230 : 130,
                            marginLeft: 10
                        }
                    }}
                    InputLabelProps={
                        {shrink: true}
                    }
                    inputProps={{
                        step: 1
                    }}
                />
                <Settings/>
            </>
        )
    }

    return (
        type === 'entityExternal' ? (
            <>
                <TypeEntity
                    field={{
                        name: 'value',
                        schema: field.field.schema || {},
                        entity: field.field.entity,
                        path: path ? `${path + '.' + index}.value` : `${index}.value`,
                        isArray: field.operand.value === 'in',
                        disabled,
                        autofocus: firstDisabledValue === index
                    }}
                    setValue={onChangeEntityExternal}
                    fieldStyles={{withoutStyles: true, width: 285}}
                    dropdownStyles={{width: 300}}
                    values={currentFilterFront}
                    onFocus={() => onFocus(`field_${index}`)}
                    onBlur={(event) => onBlur(event, index)}
                    onKeyDown={(event) => onKeyDown(event, field, index)}
                    setDropdownState={setMenuIsOpen}
                    id={`${listName}_${index}_filterValueField`}
                />
                <Settings/>
            </>
        ) : (
            <>
                {type === 'bool' ? (
                    <SelectType
                        field={{
                            name: 'filterText',
                            path: path ? `${path + '.' + index}.value` : `${index}.value`,
                            disabled: field.operand.value ? !field.operand.value.length > 0 : true,
                            type,
                            isArray: field.operand.value === 'in',
                            autofocus: firstDisabledValue === index,
                            id: `${listName}_${index}_filterValueField`,
                        }}
                        onBlur={(event) => onBlur(event, index)}
                        values={currentFilterFront}
                        setValue={onChangeEntityExternal}
                        onKeyDown={(event) => onKeyDown(event, field, index)}
                        fieldStyles={{withoutStyles: true, fullWidth: false, width: 290}}
                        onFocus={() => onFocus(`field_${index}`)}
                    />
                ) : (
                    <DefaultType
                        field={{
                            name: 'filterText',
                            path: path ? `${path + '.' + index}.value` : `${index}.value`,
                            disabled: field.operand.value ? !field.operand.value.length > 0 : true,
                            type,
                            isArray: field.operand.value === 'in',
                            autofocus: firstDisabledValue === index,
                            id: `${listName}_${index}_filterValueField`
                        }}
                        onBlur={(event) => onBlur(event, index)}
                        values={currentFilterFront}
                        setValue={onChangeEntityExternal}
                        onKeyDown={(event) => onKeyDown(event, field, index)}
                        fieldStyles={{withoutStyles: true, fullWidth: false, width: 290}}
                        onFocus={() => onFocus(`field_${index}`)}
                    />
                )}

                <Settings/>
            </>
        )
    )

};
ValueField.propTypes = {
    field: PropTypes.object,
    listName: PropTypes.string,
    onChangeRange: PropTypes.func,
    onChangeEntityExternal: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    focusedField: PropTypes.string,
    index: PropTypes.number,
    disabled: PropTypes.bool,
    currentFilterFront: PropTypes.array,
    setMenuIsOpen: PropTypes.func
};
